import FormLabel from "./FormLabel.vue";
import { pluginify } from "./../../util";
export default pluginify(FormLabel);
export { FormLabel };
